import { JobsInSamePlaceProps } from "~/types/jobs";
import Title from "~/shared/Title";
import DataTable from "~/shared/DataTable";
import React, { Dispatch, SetStateAction, useEffect } from "react";
import { PanelContainer } from "~/components/BusinessSchedulingPage/styles";

type JobsInSamaPlaceTableProps = {
    jobsInSamePlace: JobsInSamePlaceProps[];
    loading: boolean;
    setSelectedJobs: Dispatch<SetStateAction<number[]>>
    selectedJobs: number[];
    jobId: number
}

const JobsInSamaPlaceTable = ({jobsInSamePlace, setSelectedJobs, selectedJobs, loading, jobId}:JobsInSamaPlaceTableProps) => {

    const CheckBoxInput = ({ row }) => {
        return (
            <input
                type="checkbox"
                checked={selectedJobs.includes(row.jobId)}
                value={row.jobId}
                onChange={handleSelectedJobChange}
            />
        );
    };

    const selectOrClearAll = () => {
        const isChecked: HTMLInputElement = document.querySelector("#select-all");
        if (isChecked.checked) {
            const ids = jobsInSamePlace.filter(job => !selectedJobs.includes(job.jobId)).map(job => job.jobId);
            setSelectedJobs(prev => [...prev, ...ids]);
            return;
        }

        setSelectedJobs([]);
    };

    const setRowColor = (row:JobsInSamePlaceProps) => {
        return jobId === row.jobId ? "fw-bold" : "";
    };

    const handleSelectedJobChange = (e: React.ChangeEvent<HTMLInputElement> ) => {
        const { value, checked } = e.target;

        setSelectedJobs(prev => {
            if (!checked) {
                return prev.filter(j => j !== parseInt(value));
            }

            return [...prev, parseInt(value)];
        });
    };

    useEffect( () => {
        const isChecked: HTMLInputElement = document.querySelector("#select-all");
        isChecked.checked = true
        selectOrClearAll()
    }, [])


    return  (
        <>
            <header>
                <div>
                    <Title level="2">
                        Imóveis no mesmo endereço - {jobsInSamePlace[0].address}
                    </Title>
                    <small>{`(Ao selecionar os imóveis dentro da listagem será possível executar ações para todos.)`}</small>
                </div>
            </header>

            <div>
                <PanelContainer isStick={jobsInSamePlace.length >= 2}>
                    <DataTable
                        loading={loading}
                        records={jobsInSamePlace}
                        setRowColor={setRowColor}
                    >

                            <DataTable.Computed
                                label={
                                    <>
                                        <input type="checkbox" id="select-all"
                                               onClick={selectOrClearAll} />
                                    </>
                                }
                                render={(row:JobsInSamePlaceProps) => <CheckBoxInput row={row} />}
                            />

                        <DataTable.Computed
                            label="Endereço"
                            render={(row:JobsInSamePlaceProps) => (
                                <p>
                                    {row.address ? `${row.address}` : ``}
                                </p>

                            )}
                        />
                        <DataTable.Computed
                            label="Complemento"
                            render={(row:JobsInSamePlaceProps) => (
                                <p>
                                    {row.complement ? `${row.complement}` : ``}
                                </p>

                            )}
                        />
                        <DataTable.DateFromISO8601 field="jobDate" label="Data do job"
                                                   to="dd/MM/yyyy HH:mm" />
                    </DataTable>
                </PanelContainer>
            </div>
            </>
    )
}

export default JobsInSamaPlaceTable
